import { render, staticRenderFns } from "./OJTCategorySelect.vue?vue&type=template&id=d5f720d0&scoped=true"
import script from "./OJTCategorySelect.vue?vue&type=script&lang=js"
export * from "./OJTCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f720d0",
  null
  
)

export default component.exports